import { ViewContainerRef } from '@angular/core';

import { SnLonLatLike } from '@lib/geo/helpers';

export interface IGoogleMapPopupOptions<TData = any> {
  data?: TData;
  viewContainerRef?: ViewContainerRef;
  maxWidth?: number;
  disableAutoPan?: boolean;
  lonLat?: SnLonLatLike;
  pixelOffset?: google.maps.Size;
  id?: string;
}
